// @ts-ignore
import notificationsEn from '../../../strings/notify/en';
// @ts-ignore
import notificationsDa from '../../../strings/notify/da';
import store from '@/store';
import { Notify } from 'quasar';

export class NotifyHelpers {
    public static translateMessage(messageKey: string, langKey: string, attribute: string = '') {
        let languagePack = notificationsEn;

        switch (langKey) {
            case 'en':
                languagePack = notificationsEn;
                break;
            case 'da':
                languagePack = notificationsDa;
                break;
        }

        // @ts-ignore
        return languagePack[messageKey](attribute);
    }

    public static notify(
        translationKey: string,
        type: string,
        attribute: string = '',
        timeout: number = 3000,
    ): void {
        const langKey = store.getters['Localization/getLocalizationKey'];
        const message = this.translateMessage(translationKey, langKey, attribute);

        Notify.create({
            message,
            type,
            position: 'bottom-right',
            timeout,
        });
    }
}
